module.exports = __webpack_public_path__ + "img/chart.35ead31a.svg";